import React from 'react'
import { Stack, Typography, Button, Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Checkbox from 'packages/ui/Checkbox'

interface CategoryHeaderProps {
  categoryName: string
  compact?: boolean
  withBorder?: boolean
  hasSelection?: boolean
  onToggleAll?: () => void
  allSelected?: boolean
  onAddAll?: () => void
  onReset?: () => void
  isRoleEdit?: boolean
}

const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  categoryName,
  compact = false,
  withBorder = false,
  hasSelection,
  onToggleAll,
  allSelected,
  onAddAll,
  onReset,
  isRoleEdit = false
}) => {
  const { t } = useTranslation()

  const handleCheckboxChange = (e: React.MouseEvent) => {
    e.preventDefault()
    onToggleAll?.()
  }

  if (compact || isRoleEdit) {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
          <Typography
            component="span"
            variant="subtitle2"
            sx={{
              fontWeight: 500,
              fontSize: '12px',
              color: '#292929',
              textTransform: 'capitalize',
              wordBreak: 'break-word'
            }}
          >
            {t(`auth.admin.role.category.${categoryName}`)}
          </Typography>
          {categoryName === 'general' && isRoleEdit && (
            <Tooltip title={t('auth.admin.role.category.general_tooltip')} placement="right" arrow>
              <i 
                className="fa-regular fa-circle-info" 
                style={{ 
                  color: '#989898',
                  fontSize: '12px',
                  flexShrink: 0
                }} 
              />
            </Tooltip>
          )}
        </Box>
        {isRoleEdit && (
          <Button
            size="small"
            variant="text"
            onClick={() => allSelected ? onReset?.() : onAddAll?.()}
            sx={{
              fontSize: '10px',
              fontWeight: 500,
              minWidth: 'auto',
              px: 0.5,
              py: 0.5,
              color: '#989898'
            }}
          >
            {t('auth.admin.role.select_all')}
          </Button>
        )}
      </Stack>
    )
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography
        variant="h6"
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#374151',
          textTransform: 'uppercase',
          marginBottom: '8px'
        }}
      >
        {t(`auth.admin.role.category.${categoryName}`)}
      </Typography>
      <Stack sx={{ marginRight: withBorder ? '16px' : '0px' }}>
        <Checkbox
          checked={false}
          indeterminate={hasSelection}
          onChange={handleCheckboxChange}
        />
      </Stack>
    </Stack>
  )
}

export default CategoryHeader